import React from 'react';
import { Link } from '@inertiajs/react';
import BlankSVG from '@/Components/SVG/BlankSVG';

const Footer: React.FC = () => {
    return (
        <footer className="global-footer">
            <div className="global-footer__inner">
                <ul className="global-footer__link">
                    <li>
                        <a
                            href="https://www.fstage.co.jp/terms/"
                            target="_blank"
                        >
                            利用規約
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://www.fstage.co.jp/privacy/"
                            target="_blank"
                        >
                            個人情報保護方針
                        </a>
                    </li>
                </ul>
                <div className="global-footer__rights">
                    <i>&copy;</i> FSTAGE. All Rights Reserved.
                </div>
            </div>
        </footer>
    );
};

export default Footer;
